import { createGlobalStyle } from 'styled-components';
import { Colors, Color } from './Colors';
import { FontScale } from './FontScale';

const GlobalStyle = createGlobalStyle`

    * {
        box-sizing: border-box;
    }

    body {
        margin: 0; 
        padding: 0; 
        color: ${Color(Colors.black)}; // fallback color
        background-color: ${Color(Colors.white)}; // fallback color
        font-family: futura-pt, sans-serif; 
    }; 

    h1, 
    h2, 
    h3, 
    h4, 
    h5, 
    h6,
    p {
        padding: 0; 
        margin: 0; 
    }

    h1 {
        font-size: ${FontScale.size_6}; 
    }

    h2 {
        font-size: ${FontScale.size_5}; 
    }

    h3 {
        font-size: ${FontScale.size_4}; 
    }

    h4 {
        font-size: ${FontScale.size_3}; 
    }

    h5 {
        font-size: ${FontScale.size_2}; 
    }

    label { 
        color: ${Color(Colors.black)}; 
        font-weight: 600; 
    }

    h6, 
    p,
    span, 
    a,
    label,
    select,
    input,
    textarea {
        font-size: ${FontScale.size_1}; 
        font-family: futura-pt, sans-serif; 
    }

    input,
    textarea,
    select {
        display: block;
        width: 100%;
        padding: 0.5rem;
        border-radius: 4px;
        border: 1px solid ${Color(Colors.black)}; 
        margin: 1rem 0 1rem 0;
    }

    input {
        margin: 1rem 0 1.5rem 0; 
    }

    button:hover,
    a:hover, 
    input[type=file]:hover,
    input[type=file]::-webkit-file-upload-button,
    input[type=radio]  {
        cursor: pointer; 
    };
    
    a {
        color: ${Color(Colors.blue)}; 
    }

    p,
    span, 
    a,
    h1,
    h2, 
    h3, 
    h4, 
    h5,
    h6 {
        white-space: normal; 
        overflow-wrap: break-word; 
        word-break: normal; 
    }

        input[type='checkbox'] {
        width: auto; 
        margin: 0; 
        padding: 0; 
        appearance: none; 
        position: relative;
        width: 16px; 
        height: 16px; 
        border: 2px solid ${Color(Colors.darkGray)}; 
        cursor: pointer; 
        transition: background-color 0.2s ease; 
        
        &:checked {
            background-color: ${Color(Colors.blue)}; 
            border-color: ${Color(Colors.blue)}; 
        }

        &:checked::after {
            content: '✔'; 
            position: absolute;
            top: 50%; 
            left: 50%; 
            transform: translate(-50%, -50%); 
            display: block; 
            color: ${Color(Colors.white)}; 
            font-size: 14px; 
            text-align: center; 
            line-height: 14px; 
            pointer-events: none; 
        }
    }

    input[type='radio'] {
        appearance: none; 
        width: 16px; 
        height: 16px; 
        border: 2px solid ${Color(Colors.white)}; 
        background-color: inherit; 
        border-radius: 50%; 
        cursor: pointer; 
        transition: all 0.2s ease; 
        position: relative; 

        &:checked {
            border-color: ${Color(Colors.white)}; 
        }

        &:checked::after {
            content: "";
            position: absolute; 
            top: 50%;
            left: 50%; 
            transform: translate(-50%, -50%); 
            background-color: ${Color(Colors.white)}; 
            border-radius: 50%; 
            width: 8px; 
            height: 8px; 
        }
    }
`; 

export default GlobalStyle